class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
  }

  open() {
    this.notification.classList.add('animate', 'active');

    this.notification.addEventListener(
      'transitionend',
      () => {
        this.notification.focus();
        trapFocus(this.notification);
      },
      { once: true }
    );

    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    this.notification.classList.remove('active');
    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
    this.cartItemKey = parsedState.key;
    this.getSectionsToRender().forEach((section) => {
      const target = document.getElementById(section.id);
      if (!target || !parsedState.sections || !parsedState.sections[section.id]) return;
      try {
        target.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
      } catch (e) {
        console.error('[HOC] cart notification render failed', section.id, e);
      }
    });

    if (typeof window.hocRefreshCart === 'function') window.hocRefreshCart({ count: true });
    if (this.header) this.header.reveal();
    this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      {
        id: 'cart-notification-button',
      },
      {
        id: 'hoc-shipping-bar',
      },
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);

/* =====================================================================
   HOC cart sync
   Keeps the header basket count (desktop + mobile), the free-shipping
   bars and the cart page in step after ANY successful cart change,
   including changes made by apps (Glood, EG Auto Add to Cart, etc.).
   ===================================================================== */
(function () {
  if (window.__hocCartSync) return;
  window.__hocCartSync = true;

  const CART_MUTATION = new RegExp('/cart/(add|change|update|clear)([.]js)?([?]|$)');
  const nativeFetch = window.fetch.bind(window);
  let timer;
  let seq = 0;
  let pending = { count: false, bars: false, page: false };

  // Updates the custom header bubbles used by this theme (ids set in sections/header.liquid)
  window.hocSetCartCount = function (count) {
    [
      ['cart-count-bubble', 'cart-count-number'],
      ['cart-count-bubble-mobile', 'cart-count-number-mobile'],
    ].forEach(function (ids) {
      const bubble = document.getElementById(ids[0]);
      const number = document.getElementById(ids[1]);
      if (!bubble || !number) return;
      if (count > 0) {
        number.textContent = count;
        bubble.classList.remove('hoc-bubble-init');
        bubble.style.display = 'inline-block';
      } else {
        number.textContent = '';
        bubble.classList.add('hoc-bubble-init');
        bubble.style.display = 'none';
      }
    });
  };

  function sectionInner(html, selector) {
    const el = new DOMParser().parseFromString(html, 'text/html').querySelector(selector || '.shopify-section');
    return el ? el.innerHTML : null;
  }

  async function run(opts) {
    const mySeq = ++seq;
    try {
      const cart = await nativeFetch('/cart.js', { credentials: 'same-origin' }).then((r) => r.json());
      if (mySeq !== seq) return;
      window.hocSetCartCount(cart.item_count);

      const itemsEl = document.getElementById('main-cart-items');
      const footerEl = document.getElementById('main-cart-footer');
      const last = window.__hocLastRendered;
      const needsPage =
        opts.page &&
        itemsEl &&
        footerEl &&
        (!last || last.count !== cart.item_count || last.total !== cart.total_price);
      const barSlots = opts.bars ? document.querySelectorAll('#hoc-shipping-bar, [data-hoc-shipping-bar]') : [];

      const ids = [];
      if (barSlots.length) ids.push('hoc-shipping-bar');
      if (needsPage) ids.push(itemsEl.dataset.id, footerEl.dataset.id);
      if (!ids.length) return;

      const sections = await nativeFetch('/cart?sections=' + ids.join(','), { credentials: 'same-origin' }).then((r) =>
        r.json()
      );
      if (mySeq !== seq) return;

      if (barSlots.length && sections['hoc-shipping-bar']) {
        const inner = sectionInner(sections['hoc-shipping-bar']);
        if (inner !== null) barSlots.forEach((slot) => (slot.innerHTML = inner));
      }

      if (needsPage) {
        [itemsEl, footerEl].forEach((el) => {
          const html = sections[el.dataset.id];
          const dst = el.querySelector('.js-contents');
          if (!html || !dst) return;
          const inner = sectionInner(html, '.js-contents');
          if (inner !== null) dst.innerHTML = inner;
        });
        const empty = cart.item_count === 0;
        const cartItems = document.querySelector('cart-items');
        if (cartItems) cartItems.classList.toggle('is-empty', empty);
        footerEl.classList.toggle('is-empty', empty);
        window.__hocLastRendered = { count: cart.item_count, total: cart.total_price };
        document.dispatchEvent(new CustomEvent('cart:updated'));
      }
    } catch (e) {
      console.error('[HOC cart sync]', e);
    }
  }

  // opts: { count, bars, page } - requests are merged and debounced
  window.hocRefreshCart = function (opts) {
    opts = opts || { count: true, bars: true, page: true };
    pending.count = pending.count || !!opts.count;
    pending.bars = pending.bars || !!opts.bars;
    pending.page = pending.page || !!opts.page;
    clearTimeout(timer);
    timer = setTimeout(() => {
      const todo = pending;
      pending = { count: false, bars: false, page: false };
      run(todo);
    }, 120);
  };

  // The older helper in layout/theme.liquid now routes through the same sync
  window.updateCartBubble = function () {
    window.hocRefreshCart({ count: true });
  };

  function isCartMutation(url) {
    return typeof url === 'string' && CART_MUTATION.test(url);
  }

  function onCartMutation() {
    window.hocRefreshCart({ count: true, bars: true, page: true });
  }

  window.fetch = function (input, init) {
    const url = typeof input === 'string' ? input : (input && (input.url || input.href)) || '';
    const request = nativeFetch(input, init);
    if (isCartMutation(url)) {
      request
        .then((response) => {
          if (response.ok) onCartMutation();
        })
        .catch(() => {});
    }
    return request;
  };

  const nativeOpen = XMLHttpRequest.prototype.open;
  const nativeSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function (method, url) {
    this.__hocUrl = url ? String(url) : '';
    return nativeOpen.apply(this, arguments);
  };
  XMLHttpRequest.prototype.send = function () {
    if (isCartMutation(this.__hocUrl)) {
      this.addEventListener('load', () => {
        if (this.status >= 200 && this.status < 300) onCartMutation();
      });
    }
    return nativeSend.apply(this, arguments);
  };
})();

/* =====================================================================
   HOC Judge.me reviews carousel (desktop + mobile, same behaviour):
   - long reviews end with "..." (Judge.me default)
   - tap the review text to show it in full, with "Read less" at the end
   - tap the product picture to open the product
   ===================================================================== */
(function () {
  if (window.__hocJdgmCarousel) return;
  window.__hocJdgmCarousel = true;

  const style = document.createElement('style');
  style.textContent = [
    '.jdgm-carousel-item .jdgm-carousel-item__review-content { cursor: pointer; }',
    '.jdgm-carousel-item.hoc-open .jdgm-line-clamp { -webkit-line-clamp: unset !important; display: block !important; overflow: visible !important; text-overflow: clip !important; }',
    '.jdgm-carousel-item.hoc-open { max-height: none !important; height: auto !important; }',
    '.hoc-read-more { display: none !important; }',
    '.hoc-read-less { display: inline-block; margin: 6px 0 4px; color: #C4885C; font-size: 14px; font-weight: 600; text-decoration: underline; cursor: pointer; }',
  ].join(' ');
  document.head.appendChild(style);

  function unlockHeights(item, open) {
    let el = item.parentElement;
    for (let i = 0; el && i < 5; i++, el = el.parentElement) {
      el.style.height = open ? 'auto' : '';
      el.style.maxHeight = open ? 'none' : '';
      if (el.classList.contains('jdgm-carousel') || el.classList.contains('jdgm-carousel-wrapper')) break;
    }
  }

  function setOpen(item, open) {
    item.classList.toggle('hoc-open', open);
    unlockHeights(item, open);
    const existing = item.querySelector('.hoc-read-less');
    if (open && !existing) {
      const body = item.querySelector('.jdgm-carousel-item__review-body');
      if (!body) return;
      const less = document.createElement('span');
      less.className = 'hoc-read-less';
      less.setAttribute('role', 'button');
      less.setAttribute('tabindex', '0');
      less.textContent = 'Read less';
      body.insertAdjacentElement('afterend', less);
    } else if (!open && existing) {
      existing.remove();
    }
  }

  function isTruncated(item) {
    const body = item.querySelector('.jdgm-carousel-item__review-body');
    const title = item.querySelector('.jdgm-carousel-item__review-title');
    return [body, title].some((el) => el && el.scrollHeight - el.clientHeight > 2);
  }

  document.addEventListener('click', (e) => {
    const item = e.target.closest('.jdgm-carousel-item');
    if (!item) return;

    if (e.target.closest('.hoc-read-less')) {
      setOpen(item, false);
      return;
    }
    if (e.target.closest('img')) {
      const link = item.querySelector('a[href*="/products/"]');
      if (link) {
        window.location.href = link.href;
        return;
      }
    }
    if (e.target.closest('a')) return;
    if (!e.target.closest('.jdgm-carousel-item__review-content, .jdgm-carousel-item__review')) return;

    if (item.classList.contains('hoc-open')) {
      setOpen(item, false);
    } else if (isTruncated(item)) {
      setOpen(item, true);
    }
  });
})();